import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  return (
    <div>
      <style>
        {`
        .counter-section {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 300px; /* Adjust height as needed */
}

.fact-counter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.row.justify-content-center {
  display: flex;
  justify-content: center;
  width: 100%;
}

.content-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
}

        `}
      </style>
      {/* Page Title Section */}
      <section
        className="page-title"
        style={{ backgroundImage: `url(/images/t1.jpg)` }}
      >
        <div className="auto-container">
          <h2>About Us</h2>
          <ul className="page-breadcrumb">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li> / About Us</li>
          </ul>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section" style={{ backgroundColor: "#f7f7f7" }}>
        <div className="auto-container">
          <div className="row clearfix">
            <div className="content-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <h2>Our Legacy in Jewelry Craftsmanship</h2>
                <div className="bold-text">
                  Celebrating timeless beauty and elegance through exquisite
                  jewelry designs.
                </div>
                <div className="text">
                  <p>
                    Our journey began with a passion for creating stunning
                    jewelry pieces that captivate the hearts of our customers.
                    Each design reflects meticulous craftsmanship and a
                    commitment to excellence.
                  </p>
                  <p>
                    We believe in transforming precious metals and gemstones
                    into timeless works of art. With years of experience and a
                    deep understanding of the art of jewelry-making, we bring
                    dreams to life, one masterpiece at a time.
                  </p>
                </div>
              </div>
            </div>

            <div className="image-column col-lg-6 col-md-12 col-sm-12">
              <div className="inner-column">
                <div className="image">
                  <img src="/images/Banner.jpg" alt="Our Story" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Interior Section */}
      <section className="interior-section style-three">
        <div className="auto-container">
          <div className="inner-container">
            <div className="row clearfix">
              <div className="image-column col-lg-4 col-md-12 col-sm-12">
                <div className="inner-column">
                  <div className="image">
                    <img
                      src="/assert/photos/JewelryBannerAbout_2.png"
                      alt="Jewelry Crafting"
                    />
                  </div>
                </div>
              </div>

              <div className="content-column col-lg-8 col-md-12 col-sm-12">
                <div className="inner-column">
                  <h2>Why Choose Us for Jewelry</h2>
                  <div className="text">
                    We combine tradition with innovation to create jewelry that
                    stands out. Each piece tells a story, crafted with precision
                    and a passion for excellence.
                  </div>
                  <div className="row clearfix">
                    <FeatureBlock
                      icon="flaticon-diamond"
                      title="Exceptional Quality"
                    />
                    <FeatureBlock
                      icon="flaticon-gem"
                      title="Exquisite Designs"
                    />
                    <FeatureBlock
                      icon="flaticon-crown"
                      title="Unparalleled Craftsmanship"
                    />
                  </div>
                  <div className="bold-text">
                    Let us help you shine brighter with our exclusive jewelry
                    collection.
                  </div>
                  <div className="column-text">
                    Explore our catalog and find the perfect piece for every
                    occasion.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Counter Section */}
      <section className="counter-section style-two">
        <div className="auto-container">
          <div className="fact-counter">
            <div className="row justify-content-center">
              <div className="content-column col-lg-6 col-md-12 col-sm-12 text-center">
                <CounterColumn
                  count={300}
                  suffix="+"
                  label="Exclusive Designs"
                />
              </div>
              <div className="content-column col-lg-6 col-md-12 col-sm-12 text-center">
                <CounterColumn
                  count={100}
                  suffix="%"
                  label="Customer Satisfaction"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

// FeatureBlock Component
const FeatureBlock = ({ icon, title }) => (
  <div className="interior-block col-lg-4 col-md-4 col-sm-12">
    <div className="block-inner">
      <div className="icon-box">
        <span className={`icon ${icon}`}></span>
      </div>
      <h3>{title}</h3>
    </div>
  </div>
);

// CounterColumn Component with Dynamic Counting
const CounterColumn = ({ count, suffix, label }) => (
  <div className="column counter-column col-lg-3 col-md-6 col-sm-12">
    <div className="inner">
      <div className="content">
        <div className="count-outer count-box">
          <CountUp end={count} duration={2} suffix={suffix || ""} />
        </div>
        <h4 className="counter-title">{label}</h4>
      </div>
    </div>
  </div>
);

export default About;
